export default __webpack_public_path__ + "static/media/clients.3848fee3.svg";